module.exports = __webpack_public_path__ + "static/vudu-2bf9813fced3ce1bddacb2491b4517bc.png";